import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
// Scrollbar global: theme.css @layer base
import "./styles/theme.css";
import "./styles/sweet-alert.css";
import App from "./App.tsx";
import { SWRConfig } from "swr";
import { swrConfig } from "./lib/swr-config";
import { AppModalProvider } from "./components/ui/use-app-modal";
import { ThemeProvider } from "./components/theme-provider";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider defaultTheme="light" storageKey="unifik-theme">
      <SWRConfig value={swrConfig}>
        <AppModalProvider>
          <Suspense
            fallback={
              <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
                  <p className="text-muted-foreground">
                    Cargando aplicación...
                  </p>
                </div>
              </div>
            }
          >
            <App />
          </Suspense>
        </AppModalProvider>
      </SWRConfig>
    </ThemeProvider>
  </StrictMode>
);
